import companyReducer from '@company/features/index.company';
import secondaryMarketReducer from '@market/features/index.market';
import ISecondaryMarketReducer from '@market/interfaces/ISecondaryMarketReducer';
import ICompanyReducer from '@company/interfaces/ICompanyReducer';
import userInfo, { TUserInfo } from './reducer.info';
import appSettings from './reducer.bfAppSettings';
import fundsReducer from '@funds/features/reducer.funds';
import portfolioReducer from '@portfolio/features/reducer.portfolio';
import IFundsReducer from '@funds/interfaces/IFundsReducer';
import { combineReducers } from 'redux';
import { IBFAppSettings } from '@appInterfaces/IBFAppSettings';
import { IPortfolioReducer } from '@apps/PortfolioApp/IPortfolioReducer';

export type TReducers = {
  secondaryMarketReducer: ISecondaryMarketReducer;
  companyReducer: ICompanyReducer;
  fundsReducer: IFundsReducer;
  portfolioReducer: IPortfolioReducer;
  userInfo: TUserInfo;
  appSettings: IBFAppSettings;
};

const mainReducers = combineReducers<TReducers>({
  companyReducer,
  secondaryMarketReducer,
  fundsReducer,
  portfolioReducer,
  userInfo,
  appSettings,
});

export default mainReducers;
